var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 377,
    viewBox: "0 0 140 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5081 59.7993C53.4041 75.7154 75.7362 120.394 90.9156 157.163C105.605 192.744 87.438 223.904 77.6258 263.146C67.012 305.595 71.8529 349.53 34.1814 365.581C-1.90314 380.956 -5.57433 308.72 -40.0542 293.927C-69.8137 281.16 -130.73 313.746 -150.265 286.447C-174.899 252.024 -221.203 193.59 -211.83 148.987C-201.769 101.105 -128.527 123.796 -87.3917 102.816C-48.1351 82.7948 -18.3865 42.0057 19.5081 59.7993Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6718 74.239C47.2296 88.5874 67.3626 128.865 81.0473 162.011C94.2901 194.088 77.9127 222.177 69.0673 257.554C59.4992 295.821 63.8637 335.428 29.9025 349.897C-2.6279 363.757 -5.93811 298.638 -37.0222 285.302C-63.8508 273.792 -118.767 303.167 -136.378 278.558C-158.586 247.526 -200.331 194.847 -191.881 154.638C-182.811 111.474 -116.783 131.93 -79.6991 113.017C-44.309 94.9685 -17.4907 58.198 16.6718 74.239Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5043 83.7149C42.7551 96.9794 61.3695 134.211 74.0223 164.85C86.2666 194.501 71.1273 220.465 62.9516 253.165C54.1079 288.536 58.1446 325.147 26.7489 338.52C-3.32427 351.33 -6.38759 291.137 -35.1249 278.809C-59.928 268.168 -110.695 295.318 -126.978 272.57C-147.51 243.884 -186.105 195.189 -178.296 158.022C-169.912 118.123 -108.869 137.035 -74.587 119.555C-41.8704 102.873 -17.0791 68.8858 14.5043 83.7149Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3489 95.9277C34.4989 107.263 50.4183 139.066 61.2404 165.237C71.7132 190.563 58.7795 212.734 51.7993 240.66C44.2489 270.867 47.7082 302.136 20.8765 313.55C-4.82489 324.483 -7.45778 273.074 -32.0234 262.538C-53.226 253.444 -96.6119 276.62 -110.535 257.187C-128.091 232.683 -161.091 191.085 -154.425 159.344C-147.269 125.27 -95.0894 141.437 -65.7915 126.516C-37.8317 112.276 -16.65 83.255 10.3489 95.9277Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0142 105.756C33.0096 116.084 47.5009 145.077 57.3508 168.937C66.8826 192.026 55.0939 212.246 48.7265 237.712C41.8389 265.257 44.9801 293.768 20.5346 304.184C-2.88103 314.161 -5.26301 267.286 -27.6373 257.687C-46.9484 249.401 -86.4774 270.547 -99.154 252.833C-115.139 230.495 -145.186 192.576 -139.104 163.632C-132.575 132.561 -85.0474 147.285 -58.3543 133.671C-32.8802 120.678 -13.5759 94.2095 11.0142 105.756Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45311 117.933C27.6283 126.939 40.2591 152.222 48.844 173.03C57.1517 193.166 46.8717 210.802 41.3177 233.011C35.31 257.035 38.0455 281.899 16.7321 290.986C-3.68338 299.69 -5.75506 258.809 -25.2606 250.44C-42.0957 243.216 -76.5605 261.663 -87.6105 246.215C-101.544 226.735 -127.736 193.668 -122.43 168.425C-116.735 141.326 -75.3006 154.162 -52.0273 142.286C-29.8169 130.952 -12.984 107.866 8.45311 117.933Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60867 125.335C26.0917 133.546 37.6062 156.605 45.4321 175.581C53.0053 193.944 43.6306 210.03 38.5647 230.286C33.0849 252.197 35.577 274.873 16.1428 283.162C-2.47258 291.102 -4.35808 253.818 -22.1424 246.187C-37.4919 239.6 -68.9182 256.426 -78.9921 242.339C-91.6952 224.574 -115.574 194.418 -110.734 171.395C-105.538 146.68 -67.7604 158.384 -46.5389 147.55C-26.2867 137.212 -10.9367 116.155 8.60867 125.335Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72989 148.154C18.0348 153.933 26.1403 170.158 31.6494 183.51C36.9806 196.431 30.384 207.748 26.82 221.999C22.965 237.416 24.7205 253.371 11.0435 259.202C-2.05728 264.787 -3.3869 238.554 -15.9038 233.183C-26.7071 228.548 -48.8234 240.384 -55.9144 230.471C-64.8559 217.971 -81.6637 196.752 -78.2591 180.554C-74.6041 163.165 -53.1398 161.24 -38.2052 153.619C-23.9526 146.347 -8.02657 141.694 5.72989 148.154Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7436 158.342C13.6373 162.983 20.1643 175.993 24.6023 186.699C28.8971 197.06 26.5567 207.198 20.7514 217.545C18.2327 220.379 18.0569 220.921 12.7957 223.154C2.27135 227.62 -3.51214 230.79 -13.5759 226.475C-22.2619 222.751 -40.0269 232.221 -45.7336 224.27C-52.9295 214.244 -66.4542 197.224 -63.7308 184.244C-60.8071 170.309 -43.5583 168.784 -31.5616 162.687C-20.1129 156.869 -7.31722 153.153 3.7436 158.342Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.56435 167.907C5.76041 171.332 10.6147 180.885 13.9196 188.744C17.1177 196.35 15.4099 203.777 11.1411 211.351C9.2853 213.423 9.15656 213.82 5.27189 215.445C-2.4989 218.696 -6.76761 221.007 -14.2174 217.822C-20.6472 215.072 -33.7599 221.975 -37.9965 216.134C-43.3388 208.767 -53.3755 196.258 -51.3908 186.748C-49.2603 176.538 -36.5116 175.458 -27.656 171.015C-19.2048 166.775 -9.75318 164.078 -1.56435 167.907Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.94057 176.75C-2.57591 178.788 0.32339 184.456 2.29851 189.119C4.20985 193.631 3.19984 198.033 0.664969 202.52C-0.438138 203.746 -0.514429 203.982 -2.82603 204.942C-7.45011 206.862 -10.8465 210.14 -13.4499 210.213C-16.0533 210.286 -16.5715 212.949 -28.5894 205.31C-31.7772 200.937 -37.7651 193.512 -36.5921 187.875C-35.3329 181.823 -27.7428 181.195 -22.4738 178.569C-17.4456 176.063 -11.8201 174.473 -6.94057 176.75Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.9591 181.302C-5.78928 182.781 -3.68196 186.891 -2.24605 190.272C-0.856509 193.544 0.364178 197.297 -3.42679 199.987C-4.22722 200.875 -4.28252 201.046 -5.96051 201.741C-9.31711 203.132 -11.7818 205.507 -13.672 205.559C-15.5622 205.61 -19.5949 207.277 -24.6661 201.998C-26.9824 198.827 -31.3329 193.441 -30.4835 189.355C-29.5717 184.968 -24.061 184.516 -20.2365 182.614C-16.5866 180.799 -12.5029 179.649 -8.9591 181.302Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectorLeft);
export default __webpack_public_path__ + "static/media/DirectorLeft.ae8185867a247a8ed3267256bd39bd4c.svg";
export { ForwardRef as ReactComponent };